<template>
  <div>
    <v-sheet
      v-if="loading"
      :color="'grey lighten-4'"
      class="pa-3"
    >
      <v-skeleton-loader type="card-heading, table-row-divider">
      </v-skeleton-loader>
    </v-sheet>
    <fragment>
      <page-head
        small
        :title="requestType.header"
        back-route-path="/bankruptcy"
      >
      </page-head>
      <page-content small>
        <div
          v-if="!isNewMode"
          class="request-info-root"
        >
          <div v-if="formModel.requestCode">
            <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.requestCode }}</span> {{ request.subRequestCode }}</b>
          </div>
          <div v-if="formModel.requestDate">
            <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.requestDate }}</span> {{ request.requestDate | hijriDate }}</b>
          </div>
          <div v-if="formModel.requestStatusName">
            <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.status }}</span> {{ request.requestStatusName }}</b>
          </div>
        </div>

        <!-- request summary  -->
        <div v-if="formModel.mainRequest">
          <request-summary :request-info="formModel.mainRequest"></request-summary>
        </div>

        <div
          v-if="isChild && formModel.parentInfo"
          class="attribute-item-row-sub my-3 d-flex"
        >
          <div
            v-for="attribute in subRequestDisplayItems"
            :key="attribute.key"
            class="attribute-item pa-1"
          >
            <div class="attribute-item-title">
              {{ attribute.displayName }}
            </div>
            <div class="attribute-item-value">
              {{ attribute.formatter ?
                attribute.formatter(formModel.parentInfo[attribute.key]) : formModel.parentInfo[attribute.key] }}
            </div>
          </div>
        </div>
        <!-- request summary  -->
        <div
          v-if="showTabs"
          class="content-border row"
        >
          <div class="col-2 tabs-box">
            <v-tabs
              v-model="tab"
              vertical
              hide-slider
            >
              <v-tab
                v-for="t in enabledTabs"
                :key="t.href"
                :href="t.href"
                class="tab-button"
                active-class="tab-active"
              >
                <v-icon
                  left
                  class="tab-button-icon"
                >
                  {{ t.icon }}
                </v-icon>
                <span class="mr-1">{{ t.title }}</span>
              </v-tab>
            </v-tabs>
            <naj-button
              text
              class="back"
              @click="goToMainRequest()"
            >
              <v-icon class="blackText">
                mdi-arrow-right
              </v-icon>
              <span class="textBack blackText">{{ local.common.returnToMainRequest }}</span>
            </naj-button>
          </div>

          <div class="col-10 p-2 tabs-section">
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-if="tab == 'tab-1'"
                value="tab-1"
              >
                <sub-request-info
                  :form-model="formModel"
                  :request-type="requestType"
                  :request-custom-data="requestCustomData"
                  :is-new-mode="isNewMode"
                  :is-edit-mode="isEditMode"
                  :is-view-mode="isViewMode"
                  :is-internal="isInternal"
                  :is-organization-user="isOrganizationUser"
                  :is-valid-for-edit="isValidForEdit"
                  :attachment-types="attachmentTypes"
                  :show-objection-form="showObjectionForm"
                ></sub-request-info>
              </v-tab-item>
              <v-tab-item
                v-if="tab == 'tab-2'"
                value="tab-2"
              >
                <objections-tab :sub-request-object-key="formModel.objectKey"></objections-tab>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
        <div v-else>
          <sub-request-info
            :form-model="formModel"
            :request-type="requestType"
            :request-custom-data="requestCustomData"
            :is-new-mode="isNewMode"
            :is-edit-mode="isEditMode"
            :is-view-mode="isViewMode"
            :is-internal="isInternal"
            :is-organization-user="isOrganizationUser"
            :is-valid-for-edit="isValidForEdit"
            :attachment-types="attachmentTypes"
            :show-objection-form="showObjectionForm"
          ></sub-request-info>
        </div>
      </page-content>
    </fragment>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { mode } from '@/helpers/enum';
import { subRequestActionType, requestReplyTypes, subRequestStatus } from '@/modules/bankruptcy/helpers/enum';
import RequestSummary from './request-summary.vue';
import { toHijriDate } from '@/helpers/utils';
import ObjectionsTab from './objections-tab/index.vue';
import SubRequestInfo from './sub-request-info.vue';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapActions: mapBankruptcyActions, mapState: mapBankruptcyState } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: {
    RequestSummary,
    ObjectionsTab,
    SubRequestInfo,
  },
  data() {
    return {
      toHijriDate,
      subRequestStatus,
      mode,
      request: {},
      loading: false,
      requestType: {},
      requestCustomData: null,
      formModel: {
        reasons: [],
        attachments: [],
        objectionReplyText: '',
      },
      tab: 'tab-1',
      attachmentsDataArray: [],
      subRequestActionType,
      requestReplyTypes,
      isValidForEdit: false,
    };
  },
  computed: {
    ...mapBankruptcyState(['attachmentTypes', 'currentUser']),
    userInfo() {
      return this.currentUser;
    },
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      if (this.$route.meta.isNew) return true;
      return this.$route.params.subRequestObjectKey === null || this.$route.params.subRequestObjectKey === undefined;
    },
    isDraftExist() {
      return (this.formModel.reasons || []).some(a => a.isDraft);
    },
    isChild() {
      return this.$route.meta.isChild;
    },
    isInternal() {
      return (
        this.$route.meta.isInternal === true || this.$route.query.isInternal == 'true' || this.$route.query.isInternal == true
      );
    },
    isApplicantViewer() {
      const current = this.currentUser?.isOrganizationUser
        ? this.currentUser?.impersonatedUser?.socialId
        : this.currentUser?.socialId;

      return !!current && current === this.formModel?.requestApplicant?.identityNumber;
    },
    showTabs() {

      return !this.isNewMode && this.isApplicantViewer && this.isSubRequestOnProgress;
    },
    showObjectionForm() {
      return !this.isNewMode && !this.isApplicantViewer && this.isSubRequestOnProgress && this.isDebtorOrCreditor;
    },
    isSubRequestOnProgress() {
      return this.formModel?.statusId === subRequestStatus.onProgressConsideration;
    },
    subRequestHeaders() {
      return [
        {
          key: 'requestTypeName',
          displayName: this.local.bankruptcy.home.headers.subRequestTypeName,
        },
        {
          key: 'subRequestCode',
          displayName: this.local.bankruptcy.home.headers.subRequestCode,
        },
        {
          key: 'requestDate',
          displayName: this.local.bankruptcy.home.headers.requestDate,
          formatter: toHijriDate,
        },
        {
          key: 'requestStatusName',
          displayName: this.local.bankruptcy.home.headers.requestStatusName,
        },
      ];
    },
    subRequestDisplayItems() {
      return this.subRequestHeaders
      .map((prop) => {
          prop.value = this.formModel.parentInfo[prop.key];
          return prop;
        })
        .filter(item => item.value);
    },
    isOrganizationUser() {
      return this.currentUser.isOrganizationUser;
    },
    isDebtorOrCreditor() {
      const applicant = this.formModel.requestApplicant;
      if (!applicant || !this.currentUser) return false;

      if (this.currentUser.isOrganizationUser) {
        return (applicant.debtor?.commercialRegistrationNumber == this.currentUser.commercialRecordNumber)
          || (applicant.debtor?.unifiedNumber == this.currentUser.commercialRecordNumber)
          || (applicant.creditor?.commercialRegistrationNumber == this.currentUser.socialId)
          || (applicant.creditor?.unifiedNumber == this.currentUser.socialId);
      }

      return (applicant.creditor?.identityNumber == this.currentUser.socialId)
        || (applicant.debtor?.identityNumber == this.currentUser.socialId);
    },
    renderOrganizationApplicantDetails() {
      if (this.isNewMode || this.isEditMode) return this.isOrganizationUser;

      return this.formModel?.requestApplicant?.relatedFirmId;
    },
    tabs() {
      return [
        {
          href: '#tab-1',
          title: this.local.bankruptcy.bankruptcyFile.basicInfo.tabTitle,
          icon: 'mdi-file-table',
          disabled: false,
          isEnabled: true,
        },
        {
          href: '#tab-2',
          title: this.local.bankruptcy.subRequests.subRequestObjections.objectionReplies,
          icon: 'mdi-archive',
          disabled: false,
          isEnabled: true,
        },
      ].filter(t => t.isEnabled);
    },
    enabledTabs() {
      return this.tabs.filter(t => t.isEnabled);
    },
  },
  watch: {},
  mounted() {
    this.loading = true;

    Promise.all([this.getBankruptcyUserInfo(), this.getAttachmentTypes()])
      .then(() => {
        this.$set(this.formModel, 'isInternal', this.isInternal);

        if (this.$route.params.subRequestObjectKey) {
          this.$route.meta.isNew ? this.getMainRequest() : this.getData();
        } else {
          this.getMainRequest();
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapBankruptcyActions([
      'mainRequestInquiry',
      'getDebtorsDetails',
      'saveRelatedRequest',
      'validateRelatedRequest',
      'getRelatedRequest',
      'updateRelatedRequest',
      'getAttachmentTypes',
      'getSubRequestType',
      'getCreditorDetails',
      'checkHasAccessToSubRequest',
      'getBankruptcyUserInfo',
      'checkHasAccessToMainRequest',
    ]),
    ...mapActions(['updateCaseRelatedRequest', 'uploadAttachment']),
    getData() {
      const subRequestObjectKey = this.$route.params.subRequestObjectKey;
      this.loading = true;
      this.checkHasAccessToSubRequest(subRequestObjectKey)
        .then((res) => {
          if (res.data) {
            const searchQuery = { mainRequestObjectKey: this.$route.params.mainRequestObjectKey };
            Promise.all([
              this.mainRequestInquiry(searchQuery),
              this.getRelatedRequest(subRequestObjectKey),
              this.getDebtorsDetails(this.$route.params.mainRequestObjectKey),
              this.getSubRequestType(this.$route.params.requestType),
              this.getCreditorDetails(this.$route.params.mainRequestObjectKey),
            ])
              .then((data) => {
                const formModel = data[1].data;
                formModel.mainRequest = data[0].data;
                formModel.subRequestTypeId = data[1].data.requestTypeId;

                this.requestType = data[3].data;
                formModel.requestApplicant.isAttorneyVerified = !!formModel.requestApplicant.attorneyNumber;
                formModel.requestApplicant.debtor = data[2].data;
                if (!this.isOrganizationUser && !formModel.requestApplicant.creditor) 
                  formModel.requestApplicant.creditor = data[4].data;

                this.$set(this, 'request', formModel);
                this.$set(this, 'formModel', formModel);

                this.checkEditValidity(formModel.requestApplicant.identityNumber);
                if (this.isChild) this.fillParentInfo(data[1].data.parentSubRequestObjectKey);
                this.requestCustomData = {
                  isValidForEdit: this.isValidForEdit,
                  isChild: this.isChild,
                };
              })
              .catch(err => this.toaster.error(err.message))
              .finally(() => (this.loading = false));
          } else {
            this.toaster.error(this.local.errorPages.forbidden.title);
            this.$router.push({ path: `/bankruptcy` });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getMainRequest() {
      this.loading = true;
      const searchQuery = { mainRequestObjectKey: this.$route.params.mainRequestObjectKey };
      Promise.all([
        this.mainRequestInquiry(searchQuery),
        this.getDebtorsDetails(this.$route.params.mainRequestObjectKey),
        this.getSubRequestType(this.$route.params.requestType),
        this.getCreditorDetails(this.$route.params.mainRequestObjectKey),
      ])
        .then((data) => {
          this.requestType = data[2].data;
          this.$set(this.formModel, 'subRequestTypeId', this.requestType.id);
          this.$set(this.formModel, 'subRequestTypeCode', this.requestType.code);
          this.$set(this.formModel, 'formId', this.requestType.formId);

          if (data[0].data.code) {
            this.$set(this.formModel, 'mainRequest', { ...data[0].data });
            this.$set(this.formModel, 'mainRequestObjectKey', data[0].data.objectKey);
            this.$set(this.formModel, 'parentSubRequestObjectKey', this.$route.params.subRequestObjectKey);
            const applicant = {};
            if (data[0].data.isRequestOwner) {
              applicant.requestOwnerTypeId = data[0].data.requestOwnerTypeId;
              applicant.legalCapacityId = data[0].data.legalCapacityId;
            }
            applicant.debtor = data[1].data;
            applicant.creditor = data[3].data;

            if (
              (this.isNewMode && this.userInfo.socialId === data[1].data.identityNumber) ||
              this.userInfo.socialId === data[3].data.identityNumber
            ) {
              applicant.requestOwnerTypeId = data[0].data.requestOwnerTypeId;
            }
            this.$set(this.formModel, 'requestApplicant', applicant);
            this.checkEditValidity(this.formModel.requestApplicant.identityNumber);
            if (this.isChild) this.fillParentInfo(this.$route.params.subRequestObjectKey);
            this.requestCustomData = {
              ...data[0].data,
              isValidForEdit: this.isValidForEdit,
              isChild: this.isChild,
            };
          } else {
            this.toaster.error(this.local.caseRelatedRequest.notFound);
            this.$router.push({ path: `/bankruptcy` });
          }
        })
        .catch(err => !err.handled && this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
    fillParentInfo(objectKey) {
      this.getRelatedRequest(objectKey).then((res) => {
        if (res.data) {
          this.$set(this.formModel, 'parentInfo', res.data);
        }
      });
    },
    checkEditValidity(identityNumber) {
      const currentUserIdentityNumber = this.userInfo.isOrganizationUser
        ? this.userInfo.impersonatedUser.socialId
        : this.userInfo.socialId;
      const isIdentityMatch = currentUserIdentityNumber === identityNumber;
      this.isValidForEdit =
        this.isNewMode == true ||
        (isIdentityMatch &&
          (this.formModel.statusId === subRequestStatus.inComplete ||
            this.formModel.statusId == subRequestStatus.waitingObjectionDueDate));
    },
    editRequestReason(index) {
      this.activeReason = index;
      this.$set(this.formModel.reasons[index], 'isDraft', true);
      this.requestReasonInput = this.formModel.reasons[index].reasonText;
    },
    handleRemoveReason(index = this.activeReason) {
      this.formModel.reasons.splice(index, 1);
    },
    goToMainRequest() {
      this.loading = true;
      this.checkHasAccessToMainRequest(this.$route.params.mainRequestObjectKey)
        .then((res) => {
          if (res.data) {
            this.$router.push({ path: `/bankruptcy/bankruptcy-file/${this.formModel.mainRequestObjectKey}` });
          } else {
            this.toaster.error(this.local.errorPages.forbidden.title);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .request-info-root {
    background-color: #faf9f4;
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid #158e8d;
    margin-bottom: 20px;

    > div {
      min-width: 170px;

      > b {
        display: flex;
        width: 100%;
        justify-content: space-between;
        font-weight: 700;
        margin-bottom: 5px;

        > span {
          margin-right: 0;
          margin-left: 5px;
        }
      }
    }
  }
}

.request-reasons-warning {
  font-size: 16px;
  color: #faad14;
}

.request-reason-label {
  font-size: 20px;
}

.request-reason-text {
  font-size: 15px;
  color: #484952a0;
}

.content-wrapper {
  border: 1px solid #e4e5e6 !important;
  margin-bottom: 25px;
}

.file-name {
  font-size: 18px;
}

.file-upload-icon {
  cursor: pointer;
}

.attribute-item-row {
  display: flex;
  justify-content: space-between;
  position: relative;
  border: 1px solid #dbdbdb;
}

.attribute-item-row-sub {
  display: flex;
  border: 1px solid #dbdbdb;
  justify-content: space-evenly;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #158e8d;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #02363d;
}

.statusName {
  font-size: 14px;
}

.status-rejected {
  color: #f44336 !important;
}

.status-ok {
  color: #29af5b;
}

.head-wings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;

  .r-info {
    margin-left: 40px;
  }
}

.page-head {
  box-shadow: none !important;
  background: #fff !important;
}

.wing-1 {
  font-weight: 1000;
  font-size: 18px;
  padding-right: 80px;
}

.wing-2 {
  font-weight: bolder;
  font-size: 14px;
}

.content-box {
  padding: 0px !important;
  margin-top: 0px !important;
}

.content-border {
  border: 35px solid #faf9f4 !important;
}

.tabs-box {
  padding: 0;
  background: #faf9f4;

  .tab-button {
    font: normal normal normal 16px/24px Almarai;
    justify-content: right;
    background: #faf9f4;

    &.tab-active {
      font-weight: bold;
      color: #158e8d;
    }
  }
}

.tabs-section {
  min-height: 600px;
}

#dd span {
  width: 200px;
  border-bottom: 1px dashed #158e8d;
  display: inline-block;
}

.vertical_dashed_line {
  border-right: 1px dashed #158e8d;
  height: 500px;
}

.attribute-item {
  font-size: 14px;
  font-weight: bold;
  color: #02363d;
}

.back {
  border-top: 1px solid;
  color: #83aea8;

  .textBack {
    font-size: 14px !important;
  }

  .blackText {
    color: black;
  }
}
</style>
